import {woodMixShareSummary} from './wood-mix.js';

function required(value,label){
  const text=String(value||'').trim();
  if(!text)throw new TypeError(label+' is required');
  return text;
}

function resultStatus(isOnline){
  return isOnline()?'saved_pending_sync':'saved_offline';
}

export function createSessionWoodEditor({
  store,
  sessionId,
  sessionStatus='draft',
  isOnline=()=>globalThis.navigator?.onLine!==false
}={}){
  if(!store?.create||!store?.get||!store?.list||!store?.update||!store?.remove||!store?.reorder){
    throw new TypeError('Session wood store is required');
  }
  const session=required(sessionId,'sessionId');
  let currentStatus=String(sessionStatus||'draft').trim().toLowerCase();
  let items=Object.freeze([]);
  let editingId=null;

  function snapshot(){
    return Object.freeze({
      sessionId:session,
      sessionStatus:currentStatus,
      items,
      editingId,
      editingItem:editingId?items.find(item=>item.id===editingId)||null:null,
      shareSummary:woodMixShareSummary(items),
      offline:!isOnline()
    });
  }

  async function refresh(){
    items=await store.list(session);
    if(editingId&&!items.some(item=>item.id===editingId))editingId=null;
    return snapshot();
  }

  function setSessionStatus(value){
    currentStatus=String(value||'').trim().toLowerCase();
    return snapshot();
  }

  function beginCreate(){
    editingId=null;
    return snapshot();
  }

  async function beginEdit(id){
    const item=await store.get(required(id,'id'));
    if(!item||item.sessionId!==session)throw new Error('SESSION_WOOD_NOT_FOUND');
    editingId=item.id;
    return snapshot();
  }

  async function save(input={}){
    const saved=editingId
      ?await store.update(editingId,input,{sessionStatus:currentStatus})
      :await store.create(session,input,{sessionStatus:currentStatus});
    editingId=null;
    await refresh();
    return Object.freeze({ok:true,status:resultStatus(isOnline),saved,state:snapshot()});
  }

  async function remove(id){
    const saved=await store.remove(id,{sessionStatus:currentStatus});
    if(editingId===id)editingId=null;
    await refresh();
    return Object.freeze({ok:true,status:resultStatus(isOnline),saved,state:snapshot()});
  }

  async function move(id,direction){
    const ordered=[...items];
    const index=ordered.findIndex(item=>item.id===id);
    if(index<0)throw new Error('SESSION_WOOD_NOT_FOUND');
    const delta=direction==='up'?-1:direction==='down'?1:0;
    if(!delta)throw new TypeError('direction must be up or down');
    const target=index+delta;
    if(target<0||target>=ordered.length)return Object.freeze({ok:true,status:'unchanged',state:snapshot()});
    [ordered[index],ordered[target]]=[ordered[target],ordered[index]];
    await store.reorder(session,ordered.map(item=>item.id),{sessionStatus:currentStatus});
    await refresh();
    return Object.freeze({ok:true,status:resultStatus(isOnline),state:snapshot()});
  }

  return Object.freeze({
    refresh,
    snapshot,
    setSessionStatus,
    beginCreate,
    beginEdit,
    save,
    remove,
    move
  });
}
